module.exports = __webpack_public_path__ + "static/blue-logo@2x-f6f79ea7274204bfab629b3fa1ea9554.png";